var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('evaluations-list',{attrs:{"title":'label_sideMenu_evaluation_administrator_evaluations_title',"isReportsList":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }